import React from 'react';

import Link from 'components/common/link';
import { Button } from 'components/common/Button';

import { routePaths } from 'appConfig';

import { useAuth, redirectToLoginPage } from 'lib/auth';

const User = () => {
  const { session, loading, loggingOut, signOut } = useAuth();

  if (loading) return <p>Loading...</p>;

  if (!session)
    return (
      <Button
        onClick={() => redirectToLoginPage()}
        variant="link"
        style={{ whiteSpace: 'nowrap' }}
      >
        Sign in / Register
      </Button>
    );

  return (
    <React.Fragment>
      <p className="mb-0 tw-px-4 tw-py-6" style={{ width: '320px' }}>
        Signed in as <strong>{session?.user?.email}</strong>
      </p>
      <hr className="tw-m-1" />
      <div className="tw-flex tw-flex-col">
        <Link
          to={routePaths.ACCOUNT}
          className="tw-px-4 tw-py-2 tw-text-2xl tw-flex tw-gap-4 tw-text-[#333] hover:tw-text-primary tw-transition-all tw-items-center"
        >
          <i className="la la-user" />
          MY ACCOUNT
        </Link>
        <hr className="tw-m-1" />
        <Link
          to={routePaths.ORDERS}
          className="tw-px-4 tw-py-2 tw-text-2xl tw-flex tw-gap-4 tw-text-[#333] hover:tw-text-primary tw-transition-all tw-items-center"
        >
          <i className="la la-file-text" />
          ORDERS
        </Link>
        <hr className="tw-m-1" />
        <Link to={routePaths.ACCOUNT_PERKS} className="tw-flex">
          <div className="tw-flex tw-gap-4 tw-px-4 tw-py-2 tw-flex-row tw-items-center tw-text-2xl tw-text-[#333] hover:tw-text-current tw-transition-all">
            <i className="la la-gift" />
            YB PERKS
          </div>
        </Link>
        <hr className="tw-m-1" />
        <Button
          // style={{ backgroundColor: '#911d1e', color: 'white' }}
          className="hover:tw-border-transparent tw-flex tw-justify-start tw-px-4 tw-py-2 tw-items-center tw-gap-4 tw-text-2xl tw-text-[#333] hover:tw-text-primary tw-transition-all"
          variant="link"
          onClick={async () =>
            await signOut({ redirect: true, callbackUrl: '/' })
          }
          disabled={loggingOut}
          loading={loggingOut}
        >
          <i className="la la-sign-out tw-m-0" />
          SIGN OUT
        </Button>
      </div>
      {/* <div className="tw-flex tw-items-center tw-justify-between">
        <Button
          variant="link"
          color="secondary"
          style={{ paddingTop: '0.85rem' }}
        >
          <Link to={routePaths.ACCOUNT}>MY ACCOUNT</Link>
        </Button>
        <Button
          style={{ backgroundColor: '#911d1e', color: 'white' }}
          variant="outlined"
          onClick={signOut}
          disabled={loggingOut}
          loading={loggingOut}
        >
          SIGN OUT
        </Button>
      </div> */}
    </React.Fragment>
  );
};

export default User;
